const color = {
  brand: {
    db: {
      aliceBlue: '#e5f6fd',
      deepSkyBlue: '#00a7f0',
      deutscheBlue: '#0018a8',
      lightSkyBlue: '#7fd3f7',
    },
    platinum: {
      amAmber: '#e29317',
      antiqueWhite: '#f9e9d5',
      manhattan: '#efc895',
      mandalay: '#ba7f37',
      platinumDarkGrey: '#7c8795',
      platinumDarkBlue: '#002244',
      platinumLightGrey: '#b9b9b9',
    },
    ebanking: {
      primary: '#edf2f1',
      secondary: '#999',
      cash: '#a6b4bd',
      fxForwards: '#79499E',
      mmInstruments: '#f9ec69',
      bonds: '#437bf1',
      equities: '#aea6a4',
      oAndD: '#f5c255',
      alternatives: '#707a95',
      various: '#dddf63',
      loans: '#ac1b48',
      surplus: '#f8794d',
    },
  },
  secondary: {
    blackPearl: '#1a2129',
    cloudBurst: '#26384d',
    fjord: '#45566a',
    fjord50: '#b1b7be',
    pickledBluewood: '#525f71',
    stormGrey: '#74808f',
    mischka: '#9ea6b0',
    linkWaterGrey: '#dadde1',
    solitude: '#eceef0',
    antiFlashWhite: '#f2f3f4',
    white: '#ffffff',
  },
  accent: {
    blueViolet: '#a133dd',
    heliotrope: '#da5afc',
    razzmatazz: '#c8127e',
    wildStrawberryPink: '#fc308d',
    vividBlue: '#1ca8ed',
    babyBlue: '#6cf9fc',
    aqua: '#28e4fd',
    aquaLight: '#d1fafe',
    aquaDark: '#1ca3b5',
    iceBlue: '#24c8bd',
    camarone: '#0c6d1e',
    darkPastelGreen: '#29c547',
    pastelGreen: '#7fed98',
    lightningYellow: '#f5b344',
    macaroniAndCheese: '#fdb87a',
    crusta: '#fd7f3a',
    burntOrange: '#ca4e18',
    sunsetOrange: '#ff534f',
    pinkSalmon: '#fd8d97',
    radicalRed: '#fc3954',
    wellRead: '#ab2d3d',
    wattle: '#d4d73c',
    scooter: '#28b9c4',
    cyanAqua: '#02f1ff',
  },
  currency: [ '#81D4FA', '#F48FB1', '#E6EE9C', '#80CBC4', '#EEEEEE'],
};

// TODO extract to dbk-brand-x ?
const palette = {
  bodyText: color.secondary.cloudBurst,

  primaryActive: color.brand.platinum.amAmber,
  primaryHover: color.brand.platinum.mandalay,
  primarySelected: color.brand.platinum.manhattan,
  primaryDisabled: color.secondary.linkWaterGrey,
  primaryShadow: color.secondary.linkWaterGrey,
  primaryStrokeLine: color.secondary.fjord50,
  primaryText: color.secondary.white,
  primaryTextDisabled: color.secondary.stormGrey,
  primaryTextHeadline: color.brand.platinum.platinumDarkBlue,
  primaryError: color.accent.wellRead,
  primaryWarning: color.brand.platinum.mandalay,
  primarySuccess: color.accent.pastelGreen,
  primaryLine: color.accent.wattle,
  primaryBar: color.accent.scooter,

  secondaryText: color.secondary.stormGrey,
  secondaryActive: color.secondary.white,
  secondaryDisabled: color.secondary.solitude,
  secondaryStrokeLine: color.brand.platinum.amAmber,
  secondaryBar: color.accent.cyanAqua,

  accent: [
    color.brand.platinum.manhattan,
    color.accent.lightningYellow,
    color.accent.blueViolet,
    color.accent.vividBlue,
  ],
};

palette.dataVisualisation = palette.accent;

function setPalette(overrides = {}) {
  // Mutate palette object
  // this should stay Object.assign so that the accents can be shorter than the provided length
  Object.assign(palette, overrides);
}

module.exports = { color, palette, setPalette };
